<template>
  <div class="monitor-group-by">
    <span class="monitor-group-by__label"><AppIcon name="account_tree" /> Agrupar por</span>

    <draggable :value="value" @input="$emit('input', $event)" tag="div" class="monitor-group-by__chips"
               handle=".monitor-group-by__handle" :animation="150">
      <span v-for="(key, index) in value" :key="key" class="monitor-group-by__chip">
        <AppIcon name="drag_indicator" class="monitor-group-by__handle" v-b-tooltip.hover title="Arrastrar para cambiar el orden" />
        <span class="monitor-group-by__order">{{index + 1}}</span>
        <AppIcon :name="option(key).icon" />
        {{option(key).label}}
        <button type="button" class="monitor-group-by__remove" v-b-tooltip.hover title="Quitar nivel" @click="remove(key)">
          <AppIcon name="close" />
        </button>
      </span>
    </draggable>

    <b-dropdown v-if="available.length" size="sm" variant="link" no-caret toggle-class="monitor-group-by__add">
      <template #button-content><AppIcon name="add" /> Nivel</template>
      <b-dropdown-item v-for="item in available" :key="item.key" @click="add(item.key)">
        <AppIcon :name="item.icon" /> {{item.label}}
      </b-dropdown-item>
    </b-dropdown>

    <span v-if="!value.length" class="text-muted monitor-group-by__empty">Sin agrupar</span>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'

  // selector de niveles de agrupamiento: el orden de los chips es el orden del
  // árbol (se reordena arrastrando)
  export default {
    components: {
      draggable,
    },
    props: {
      value: { type: Array, required: true },     // keys en orden
      options: { type: Array, required: true },   // [{key, label, icon}]
    },
    computed: {
      available() {
        return this.options.filter(item => this.value.indexOf(item.key) < 0)
      },
    },
    methods: {
      option(key) {
        return this.options.find(item => item.key == key) || { label: key, icon: 'label' }
      },
      add(key) {
        this.$emit('input', this.value.concat([key]))
      },
      remove(key) {
        this.$emit('input', this.value.filter(item => item != key))
      },
    },
  }
</script>

<style scoped>
  .monitor-group-by {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
  }

  .monitor-group-by__label {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: var(--app-color-text-secondary);
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: .03em;
    margin-right: 4px;
  }

  .monitor-group-by__chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .monitor-group-by__chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 3px 4px 3px 2px;
    border: 1px solid var(--app-color-border);
    border-radius: 999px;
    background: var(--app-color-surface);
    font-size: 13px;
  }

  .monitor-group-by__chip + .monitor-group-by__chip::before {
    content: '›';
    margin: 0 4px 0 -4px;
    color: var(--app-color-text-muted);
  }

  .monitor-group-by__handle {
    cursor: grab;
    color: var(--app-color-text-muted);
  }

  .monitor-group-by__order {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary-active);
    font-size: 11px;
    font-weight: 700;
  }

  .monitor-group-by__remove {
    display: inline-flex;
    align-items: center;
    border: none;
    background: transparent;
    color: var(--app-color-text-muted);
    padding: 0 2px;
    cursor: pointer;
  }

  .monitor-group-by__remove:hover {
    color: var(--app-color-danger);
  }

  .monitor-group-by >>> .monitor-group-by__add {
    padding: 2px 8px;
    font-size: 13px;
    text-decoration: none;
  }

  .monitor-group-by__empty {
    font-size: 13px;
  }
</style>
